import {
    Component,
    Injector,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
    AfterViewInit
} from '@angular/core';
import {
    AccountServiceProxy,
    BiositeStaffDataDto,
    ChangeUserPasswordInput,
    EditAdminUserDetailsInput,
    EditSupervisorUserDetailsInput,
    EditMyOwnSupervisorUserDetailsInput,
    GetStaffUserDetailsForEditOutput,
    PasswordComplexitySetting,
    ProfileServiceProxy,
    SendEmailActivationLinkInput,
    StaffsAndUsersServiceProxy,
    StaffsServiceProxy,
    UpdateProjectAdministratorUserDetailsInput,
    UserServiceProxy,
    EditUserDetailsInput,
    EditMyOwnUserDetailsInput,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EMPTY, Observable, ReplaySubject } from '@node_modules/rxjs';
import { finalize } from '@node_modules/rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {
    FormControl,
    Validators
} from '@angular/forms';
import { Subject } from 'rxjs';
import { take, takeUntil, startWith, map } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';

import { StaffUserLookupTableModalComponent } from '@app/components/user-details/lookup-table-modal/staff-user-lookup-table-modal.component';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { PermissionCheckerService } from 'abp-ng2-module';

@Component({
    selector: 'app-user-details-manual',
    templateUrl: './user-details-manual.component.html',
    styleUrls: ['./user-details-manual.component.css'],
})
export class UserDetailsManualComponent
    extends AppComponentBase
    implements OnInit, OnChanges, AfterViewInit {
    @ViewChild('staffUserLookupTableModal', { static: true })
    staffUserLookupTableModal: StaffUserLookupTableModalComponent;

    @Input() staff: GetStaffUserDetailsForEditOutput;
    @Input() ownDetailsEdit: Boolean;
    @Input() isOnboardingCompleted: Boolean;
    @Input() isMyProfileEdit: Boolean;

    saving = false;
    savingPassword = false;
    user;
    userName = '';
    companies;
    submitted = false;
    projectId: ''

    public companyFormCtrl: FormControl = new FormControl('', [Validators.required]);
    newPassword: null;
    passwordComplexitySetting: PasswordComplexitySetting = new PasswordComplexitySetting();
    signOffPerson;
    protected _onDestroy = new Subject<void>();
    filteredCompanies: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

    constructor(
        injector: Injector,
        private _accountServiceProxy: AccountServiceProxy,
        private _profileService: ProfileServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _userService: UserServiceProxy,
        private _staffsAndUsersServiceProxy: StaffsAndUsersServiceProxy,
        private _staffsServiceProxy: StaffsServiceProxy,
        private _projectService:ProjectService,
        private _router: Router,
    ) {
        super(injector);
    }

    async ngOnInit() {
        this._profileService.getPasswordComplexitySetting().subscribe((result) => {
            this.passwordComplexitySetting = result.setting;
        });

        this.projectId = await this._projectService.getCurrentOrDefaultProjectId();

        this._staffsAndUsersServiceProxy.getCompanies().subscribe((result) => {
            this.filteredCompanies.next(result);
            this.companies = result;
            if (this.user.company) {
                this.companyFormCtrl.setValue(this.user.company);
            }
        })
        this.companyFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterCompanies();
            });

       // this.loadUser();

    }


    active = false;

    show(staffId?: number): void {
        if (!staffId) {
            this.staff = new GetStaffUserDetailsForEditOutput();
            this.staff.staffId = staffId;
            this.active = true;
        } else {
            this._staffsAndUsersServiceProxy
                .getStaffUserForEdit(staffId)
                .subscribe((result) => {
                    this.active = true;
                    this.staff = result;
                });
        }
    }

    loadUser() {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    private filterCompanies() {
        let search = this.companyFormCtrl.value.toLowerCase();
        if (!this.companies) {
            return;
        }

        if (!search) {
            this.filteredCompanies.next(this.companies.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredCompanies.next(
            this.companies?.filter(
                (company) =>
                    company.toLowerCase().indexOf(search) > -1
            )
        );

    }

    ngAfterViewInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.staff) {
            this.user = changes.staff.currentValue;

            if (!this.user.biositeStaffDetails) {
                this.user.biositeStaffDetails = new BiositeStaffDataDto();
            }

            if (this.user.lineManager) {
                this.staffUserLookupTableModal.selected = this.user.lineManager.lineManagerDetails;
                this.getSelectedUser();
            }
        }
    }

    updateUserDetails(
        params: EditUserDetailsInput
    ): Observable<any> {
        return this._staffsAndUsersServiceProxy
            .updateUserDetails(params)
            .pipe(
                finalize(() => {
                    this.saving = false;
                })
            );
    }

    updateMyOwnUserDetails(
        params: EditMyOwnUserDetailsInput
    ): Observable<any> {
        return this._staffsAndUsersServiceProxy
            .updateMyOwnUserDetails(params)
            .pipe(
                finalize(() => {
                    this.saving = false;
                    this.notify.info(this.l('SavedSuccessfully'));
                })
            );
    }

    save(): void {
        this.submitted = true;

        if (this.companyFormCtrl.hasError('required')) {
            return;
        }
        this.saveInternal().subscribe(
            (x) => {
                abp.event.trigger('app.show.mySettingsManualModalClose');
                this.notify.success(this.l('SavedSuccessfully'));
                this._router.navigate(this.projectId ? ['/app/main/resourcesAllocation/projectteam'] : ['/app/main/resourcesAllocation/staffs']);
            },
            () => { }
        );
    }

    changeUserPassword(): void {
        this.savingPassword = true;
        const body = new ChangeUserPasswordInput();
        body.userId = this.user.userId;
        body.newPassword = this.newPassword;

        this._userService.changeUserPassword(body).subscribe(
            () => {
                this.savingPassword = false;
                this.notify.success(this.l('SuccessfullyChangeUserPassword'));
                this.newPassword = null;
            },
            () => {
                this.savingPassword = false;
                this.notify.error(this.l('CannotChangeUserPassword'))
            }
        );
    }

    sendEmailActivationLink(): void {
        const body = new SendEmailActivationLinkInput();
        body.emailAddress = this.user.contactDetails.emailAddress;

        this._accountServiceProxy.sendEmailActivationLink(body).subscribe(
            () => this.notify.success(this.l('SuccessfullySendActivationEmail')),
            () => this.notify.error(this.l('CannotSendActivationEmail'))
        );
    }

    openSelectUserModal() {
        this.staffUserLookupTableModal.subordinatedStaffId = this.user.staffId;
        this.staffUserLookupTableModal.ownDetailsEdit = this.ownDetailsEdit
            ? this.ownDetailsEdit
            : false;

        this.staffUserLookupTableModal.show();
    }

    setUserIdNull() {
        this.staffUserLookupTableModal.id = null;
        this.staffUserLookupTableModal.selected = null;
        this.signOffPerson = null;
    }

    getSelectedUser() {
        if (!this.staffUserLookupTableModal.selected) return;

        this.signOffPerson = `${this.staffUserLookupTableModal.selected.contactDetails.lastName} ${this.staffUserLookupTableModal.selected.contactDetails.firstName}`;
    }

    private saveInternal(): Observable<void> {
        this.user.contactDetails.emailAddress = this.user.contactDetails.emailAddress.toLowerCase();
        this.saving = true;
        let params = new EditUserDetailsInput({
            userId: this.user.userId,
            contactDetails: this.user.contactDetails,
            lineManagerStaffId:
                (this.staffUserLookupTableModal.selected &&
                    this.staffUserLookupTableModal.selected.staffId) || null,
            jobTitle: this.user.jobTitle,
            company: this.companyFormCtrl.value,
            locations: []
            });
         return this.ownDetailsEdit
            ? this.updateMyOwnUserDetails(params)
            : this.updateUserDetails(params);
    }

    moveToUsers()
    {
        this._router.navigate(this.projectId ? ['/app/main/resourcesAllocation/projectteam'] : ['/app/main/resourcesAllocation/staffs']);
    }
}
